import React from "react";
import BaseModal from "./BaseModal";
import LoadingIndicator from "../../meta/LoadingIndicator";

function DeleteSurveyModal(props){

    const okButton = (e) => {
        e.preventDefault();
        if(props.isSurveyBeingDeleted) return;
        props.deleteSurvey(props.survey.questId);
    };

    const cancelButton = (e) => {
        e.preventDefault();
        if(props.isSurveyBeingDeleted) return;
        props.closeModal();
    };

    return props.modalShown ? (
        <BaseModal modalId={"myModal"} modalClass={"modal"}>
            <div className="modal-content">
            <span className="close" onClick={cancelButton}>&times;</span>
            <div className="modal-content__title modal-content__title--center">Are you sure you want to delete {props.survey.questTitle} survey?</div>
            <div className="modal-content__subtitle">The entire survey will be removed and all the responses collected so far will be deleted.</div>
            {props.isSurveyBeingDeleted && <div className="modal-content__subtitle"><LoadingIndicator/></div>}
            <div className="modal-content__actions modal-content__actions--center">
                <a href="#"
                   className={"modal-content__actions__btn " + (props.isSurveyBeingDeleted ? " modal-content__actions__btn--disabled " : "")}
                   onClick={okButton}>Yes, delete</a>
                <a href="#"
                   className={"modal-content__actions__btn " + (props.isSurveyBeingDeleted ? " modal-content__actions__btn--disabled " : " modal-content__actions__btn--filledBlue ")}
                   onClick={cancelButton}>No, go back</a>
            </div>
            </div>
        </BaseModal>
    ) : null;
}

export default DeleteSurveyModal;